module.exports = __webpack_public_path__ + "static/media/empower.a3679f87.png";